import { RecommendationsTitle, RecommendationsSubtitle, RecommendationsTitleTag, RecommendationsFooter, withCarouselContainer } from '@recommendations-fe/commons';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _jsx from '@babel/runtime/helpers/jsx';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { useRef, useState, useEffect, createElement } from 'react';
import 'prop-types';
import classNames from 'classnames';
import { namespaceRecommendations } from '@recommendations-fe/commons/namespaces';
import { jsxs, jsx } from 'react/jsx-runtime';
const _excluded = ["ListComponent", "listType", "className", "classnameFromResponse", "paddingHorizontal", "onTitleTagIconClick"];
const RecommendationsList$1 = _ref => {
  let {
      ListComponent,
      listType,
      className,
      classnameFromResponse,
      paddingHorizontal = 0,
      onTitleTagIconClick
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const namespace = "".concat(namespaceRecommendations, "-list");

  // Misc components props
  const {
    items,
    title,
    titleWithIcons,
    titleTag,
    subtitle,
    footer,
    href,
    IconFactory
  } = rest;

  // Card Height Setting
  const listRef = useRef();
  const [isJsLoaded, setIsJsLoaded] = useState(false);
  /* istanbul ignore next */
  useEffect(() => {
    if (listRef.current) {
      const listWrapper = listRef.current.querySelector(".".concat(namespaceRecommendations, "-list__items-wrapper--horizontal"));
      if (listWrapper) {
        const listWrapperPaddingBottom = parseFloat(window.getComputedStyle(listWrapper).paddingBottom) || 0;
        const maxCardHeight = listWrapper.getBoundingClientRect().height - listWrapperPaddingBottom;
        const maxCardHeightValue = maxCardHeight > 0 ? "".concat(maxCardHeight, "px") : 'auto';
        listRef.current.style.setProperty('--max-card-height', maxCardHeightValue);
      }
    }
    setIsJsLoaded(true);
  }, [listRef]);
  return items && items.length > 0 && /*#__PURE__*/jsxs("div", {
    className: classNames(namespace, "".concat(namespace, "__container--").concat(listType || 'generic'), className, classnameFromResponse),
    ref: listRef,
    style: {
      '--list-padding': "".concat(paddingHorizontal, "px")
    },
    children: [title && /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__header")
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__header-titles")
    }, void 0, /*#__PURE__*/_jsx(RecommendationsTitle, {
      title: title,
      titleWithIcons: titleWithIcons,
      href: href,
      IconFactory: IconFactory
    }), subtitle && /*#__PURE__*/_jsx(RecommendationsSubtitle, {
      text: subtitle.text,
      url: subtitle.url,
      IconFactory: IconFactory,
      advertisingLabel: subtitle.advertising_label
    }), titleTag && /*#__PURE__*/_jsx(RecommendationsTitleTag, {
      text: titleTag.text,
      values: titleTag.values,
      styles: titleTag.styles,
      IconFactory: IconFactory,
      onTitleTagIconClick: onTitleTagIconClick
    }))), ListComponent && /*#__PURE__*/jsx(ListComponent, _objectSpread({
      listType: listType,
      disableHover: !isJsLoaded
    }, rest)), footer && /*#__PURE__*/_jsx(RecommendationsFooter, {
      footerText: footer.text,
      href: footer.link,
      IconFactory: IconFactory,
      withChevron: true
    })]
  });
};
var RecommendationsListWithoutContainer = RecommendationsList$1;
const RecommendationsListBase = _ref => {
  let {
    Card,
    IconFactory,
    cardProps,
    items,
    title,
    listType,
    priceSizeOverride,
    hideRebates = false,
    onItemClick,
    onBookmarkClick,
    bookmarkedItems,
    bookmarkText,
    classNamesMap = {},
    classNamesIndexMap = {},
    disableHover
  } = _ref;
  const namespace = "".concat(namespaceRecommendations, "-list__items-wrapper--").concat(listType);
  return /*#__PURE__*/_jsx("ul", {
    className: namespace,
    "aria-label": title
  }, void 0, items && items.map((item, index) => {
    var _item$id;
    const ItemID = (_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : item === null || item === void 0 ? void 0 : item.metadata.id;
    const classNameFromMap = classNamesMap[item.id];
    /* eslint-disable-next-line security/detect-object-injection */
    const classNameFromIndex = classNamesIndexMap[index];
    const CardToUse = item.CustomCard || Card;
    return /*#__PURE__*/createElement(CardToUse, _objectSpread(_objectSpread(_objectSpread({}, cardProps), item), {}, {
      key: ItemID,
      classNameFromMap: classNameFromMap,
      classNameFromIndex: classNameFromIndex,
      IconFactory: IconFactory,
      onItemClick: onItemClick,
      onBookmarkClick: onBookmarkClick,
      bookmarkedItems: bookmarkedItems,
      bookmarkText: bookmarkText,
      priceSizeOverride: priceSizeOverride,
      hideRebates: hideRebates,
      isListItem: true,
      disableHover: disableHover,
      cardNumber: index
    }));
  }));
};
var ListBase = RecommendationsListBase;
const priceSizeOverride$5 = {
  price: 20,
  discount: 12,
  installments: 14,
  original: 12
};
const RecommendationsListDefault = props => /*#__PURE__*/jsx(ListBase, _objectSpread({
  priceSizeOverride: priceSizeOverride$5
}, props));
var RecommendationsListDefault$1 = RecommendationsListDefault;
const priceSizeOverride$4 = {
  price: 24,
  discount: 14,
  installments: 14,
  original: 12
};
const RecommendationsListSingle = props => /*#__PURE__*/jsx(ListBase, _objectSpread({
  priceSizeOverride: priceSizeOverride$4
}, props));
var RecommendationsListSingle$1 = RecommendationsListSingle;
const priceSizeOverride$3 = {
  price: 24,
  discount: 12,
  installments: 14,
  original: 12
};
const RecommendationsListDouble = props => /*#__PURE__*/jsx(ListBase, _objectSpread({
  priceSizeOverride: priceSizeOverride$3
}, props));
var RecommendationsListDouble$1 = RecommendationsListDouble;
const priceSizeOverride$2 = {
  price: 16,
  discount: 12,
  installments: 12,
  original: 12
};
const RecommendationsListGrid = props => /*#__PURE__*/jsx(ListBase, _objectSpread({
  priceSizeOverride: priceSizeOverride$2
}, props));
var RecommendationsListGrid$1 = RecommendationsListGrid;
const priceSizeOverride$1 = {
  price: 20,
  discount: 14,
  installments: 14,
  original: 14
};
const RecommendationsListPads = props => /*#__PURE__*/jsx(ListBase, _objectSpread({
  priceSizeOverride: priceSizeOverride$1
}, props));
var RecommendationsListPads$1 = RecommendationsListPads;
const priceSizeOverride = {
  price: 20,
  discount: 12,
  installments: 12,
  original: 12
};
const RecommendationsListHorizontal = props => /*#__PURE__*/jsx(ListBase, _objectSpread({
  priceSizeOverride: priceSizeOverride
}, props));
var RecommendationsListHorizontal$1 = RecommendationsListHorizontal;
const RecommendationsList = withCarouselContainer(RecommendationsListWithoutContainer);
export { RecommendationsList, RecommendationsListDefault$1 as RecommendationsListDefault, RecommendationsListDouble$1 as RecommendationsListDouble, RecommendationsListGrid$1 as RecommendationsListGrid, RecommendationsListHorizontal$1 as RecommendationsListHorizontal, RecommendationsListPads$1 as RecommendationsListPads, RecommendationsListSingle$1 as RecommendationsListSingle, RecommendationsListWithoutContainer };
